import { _ as _extends } from '../../extends-30811c5e.js';
import { _ as _defineProperty } from '../../defineProperty-6f298737.js';
import { _ as _objectWithoutProperties } from '../../objectWithoutProperties-dd908bcc.js';
import React__default from 'react';
import classNames from 'classnames';

var _excluded = ["highlightColor", "size", "className"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

/* eslint-disable @typescript-eslint/no-unused-vars */

var IconReactionNegativeSmall = function IconReactionNegativeSmall(_ref) {
  _ref.highlightColor;
    var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 16 : _ref$size,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    newProps = _objectWithoutProperties(_ref, _excluded);
  var props = _objectSpread(_objectSpread({
    width: size,
    height: size
  }, newProps), {}, {
    className: classNames('sol-icon', className)
  });
  return /*#__PURE__*/React__default.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), /*#__PURE__*/React__default.createElement("g", {
    id: "icon-reaction-negative-small"
  }, /*#__PURE__*/React__default.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.11676 13.7985C6.96054 13.9287 6.76363 14 6.56029 14C6.01176 14 5.60036 13.4982 5.70793 12.9603L6.09999 11L3 11C2.44772 11 2 10.5523 2 10L2 7.9066C2 7.40405 2.1892 6.91992 2.52994 6.55053L5.50817 3.32197C5.69749 3.11674 5.96398 3.00001 6.2432 3.00001L10 3C10.5523 3 11 3.44772 11 4L11 7.81249L11 10.0941C11 10.3909 10.8682 10.6723 10.6402 10.8623L7.11676 13.7985ZM13.5 10C13.7761 10 14 9.77614 14 9.5L14 3.5C14 3.22386 13.7761 3 13.5 3L12.5 3C12.2239 3 12 3.22386 12 3.5L12 9.5C12 9.77614 12.2239 10 12.5 10L13.5 10Z",
    fill: "currentColor"
  })));
};

export { IconReactionNegativeSmall };
